<br />
<br />
<p style="text-align: center">
  <strong style="font-size: 5pt; position: relative; top: -5px"
    >&#10033;</strong
  >
  <strong style="font-size: 14pt">סוף תעודת בדיקה</strong>
  <strong style="font-size: 5pt; position: relative; top: -5px"
    >&#10033;</strong
  >
</p>
